export const NO_IMAGE_PLACEHOLDER_URL = '/assets/no-image.svg';
export const NO_PROFILE_IMAGE_PLACEHOLDER_URL = '/assets/no-profile-image.png';
